var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6189 18.5172C15.2135 18.8479 14.6162 18.8243 14.2378 18.4463L8.39586 12.604C8.20002 12.4081 8.09401 12.1461 8.09401 11.8744C8.09401 11.6025 8.19984 11.341 8.39586 11.1444L14.238 5.3023C14.6415 4.89923 15.2947 4.89923 15.6972 5.3023C16.1009 5.70551 16.1009 6.35889 15.6973 6.76188L10.5853 11.8744L15.6972 16.9867C16.0757 17.3647 16.0993 17.9626 15.7682 18.368L15.6973 18.4464L15.6189 18.5172Z",
    fill: "#116E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.25b439a7de1fe5891bd3f6ba0fecaae1.svg";
export { ForwardRef as ReactComponent };